module.exports = __webpack_public_path__ + "static/feature-quality-2166589113606aec93ff93534ca5cff4.svg";